import { CustomerController, TransactionsController, SettingsController, InventoryController } from '../../controllers';
import { customerStore, transactionStore, userStore } from '../../stores';
import Transactions from '../../pages/Transactions/Transactions';
import { theYear } from '../../utils/utils';
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { object, string } from 'yup';
import moment from 'moment';
import { getDate } from '../../utils/utils';
import { filterPeriods } from '../../utils/utils';

const {
	transactions,
	transactionSummary,
	expenseAnalysis,
} = TransactionsController;


const TransactionsContainer = () => {
	const [loading, setLoading] = useState(false);
	const [filterPeriod, setFilterPeriod] = useState(`${theYear}`);
	const setCustomers = async () => {
		if (
			customerStore.customers.length === 0 &&
			userStore.isOnBoardingDone !== 'false'
		) {
			await CustomerController.getCustomers();
		}
		return customerStore.customers;
	};

	useEffect(() => {
		const setTransactions = async () => {
			setLoading(true);
			await Promise.all([
				transactions(),
				transactionSummary(),
				// SettingsController.expenseCategories(),
				expenseAnalysis(),
			]);
			setLoading(false);
		};
		setTransactions();
	}, []);
	const validationSchema = () => {
		return object({
			startDate: string().required('Start Date is required'),
			endDate: string().required('End Date is required'),
		});
	};

	const onSubmit = async payload => {
		let query;

		if (payload && Object.keys(payload).length > 0) {
			query = `startDate=${payload.startDate}&endDate=${payload.endDate}&dateField=createdAt`;
			if (payload.period === "custom") {
				setFilterPeriod(
					`${moment(payload?.startDate).format("DD-MM-YYYY")} - ${moment(payload.endDate).format("DD-MM-YYYY")}`
				);
			} else {
				setFilterPeriod(
					`${payload?.periodText}`
				);
			}
		}
		setLoading(true);
		await Promise.all([
			TransactionsController.transactionSummary(query),
			TransactionsController.transactions(query),
		]);

		setLoading(false);
	};

	setCustomers();

	const logout = () => {
		userStore.setLoggedIn(false);
	};

	const [openExpensesModal, setOpenExpensesModal] = useState(false);
	const [openUpdateDebtModal, setOpenUpdateDebtModal] = useState(false);
	const [openDebtExpensesModal, setOpenDebtExpensesModal] = useState(false);
	const [openIncome, setOpenIncome] = useState(false);
	const [editIncome, setEditIncome] = useState(false);
	const [editExpense, setEditExpense] = useState(false);
	const [viewMoreExpense, setViewMoreExpense] = useState(false);
	const [viewMoreIncome, setViewMoreIncome] = useState(false);
	const [updateTransaction, setUpdateTransaction] = useState(false);
	const [openTagModal, setOpenTagModal] = useState(false);

	const getExpensesModal = () => {
		// isOnboardingDone();
		setOpenExpensesModal(true);
	};

	const getIncomeModal = () => {
		// isOnboardingDone();
		setOpenIncome(true);
	};

	const getUpdateDebtModal = (transaction) => {
		// isOnboardingDone();
		transactionStore.setSelectedTransaction(transaction);
		setOpenUpdateDebtModal(true);
	};
	const getDebtModal = () => {
		// isOnboardingDone();
		setOpenDebtExpensesModal(true);
	};

	const goToEditIncomeModal = () => {
		setEditIncome(true);
	};

	const goToEditExpenseModal = () => {
		setEditExpense(true);
	};

	const closeModal = () => {
		setOpenExpensesModal(false);
		setOpenIncome(false);
		setEditIncome(false);
		setEditExpense(false);
		setOpenUpdateDebtModal(false)
		setOpenDebtExpensesModal(false);
		setViewMoreExpense(false);
		setViewMoreIncome(false);
		setUpdateTransaction(false);
		setOpenTagModal(false);
	};

	const resetFilter = () => {
		onSubmit();
		setFilterPeriod(`${theYear}`);
	};
	const refresh = async () => {
		setLoading(true);
		await Promise.all([
			transactions(),
			transactionSummary(),
			expenseAnalysis(),
			CustomerController.getCustomers(),
		]);
		setLoading(false);
	};

	return (
		<Transactions
			summary={transactionStore.transactionsSummary}
			logout={logout}
			loading={loading}
			refresh={refresh}
			openUpdateDebtModal={openUpdateDebtModal}
			getUpdateDebtModal={getUpdateDebtModal}
			openExpensesModal={openExpensesModal}
			onSubmit={onSubmit}
			getExpensesModal={getExpensesModal}
			openIncome={openIncome}
			openDebtExpensesModal={openDebtExpensesModal}
			getIncomeModal={getIncomeModal}
			closeModal={closeModal}
			editIncome={editIncome}
			editExpense={editExpense}
			goToEditIncomeModal={goToEditIncomeModal}
			goToEditExpenseModal={goToEditExpenseModal}
			validationSchema={validationSchema}
			filterPeriod={filterPeriod}
			getDebtModal={getDebtModal}
			resetFilter={resetFilter}
			viewMoreExpense={viewMoreExpense}
			updateTransaction={updateTransaction}
			setViewMoreExpense={setViewMoreExpense}
			setUpdateTransaction={setUpdateTransaction}
			filterPeriods={filterPeriods}
			getDate={getDate}
			openTagModal={openTagModal}
			setOpenTagModal={setOpenTagModal}
			viewMoreIncome={viewMoreIncome}
			setViewMoreIncome={setViewMoreIncome}
		/>
	);
};

export default observer(TransactionsContainer);
